import { render } from "./NutzerschlagwortAuswahl.pug?vue&type=template&id=770aa84f&lang=pug"
import script from "./NutzerschlagwortAuswahl.js?vue&type=script&lang=js"
export * from "./NutzerschlagwortAuswahl.js?vue&type=script&lang=js"

import "./NutzerschlagwortAuswahl.css?vue&type=style&index=0&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__